import {
  ProfileDropdownButton,
  ProfileDropdownDivider,
  ProfileDropdownMenu,
  ProfileDropdownRow,
  ProfileSwatchButton,
  ProfileSwatchGrid,
  ProfileSwatchLabel,
  ProfileSwatchSection,
  ProfileSwatchWrapper
} from './styles'

interface AvailableColorCode {
  id?: number
  code: string
}

interface StudentProfileDropdownMenuProps {
  isDarkMode: boolean
  profileSwatches: AvailableColorCode[]
  selectedColorCode?: string
  selectedColorId?: number
  onThemeModeChange: () => void
  onProfileColorChange: (colorCode: AvailableColorCode) => void
  onSignOut: () => void
}

const StudentProfileDropdownMenu = ({
  isDarkMode,
  profileSwatches,
  selectedColorCode,
  selectedColorId,
  onThemeModeChange,
  onProfileColorChange,
  onSignOut
}: StudentProfileDropdownMenuProps) => {
  return (
    <ProfileDropdownMenu role='menu'>
      {!!profileSwatches.length && (
        <>
          <ProfileSwatchSection>
            <ProfileSwatchLabel>User Icon Color</ProfileSwatchLabel>
            <ProfileSwatchGrid>
              {profileSwatches.map((colorCode) => {
                /**
                 * Teacher parity highlights the active swatch either by the
                 * persisted color id or by the resolved cookie/background code.
                 * Checking both keeps the teacher-style selected state stable
                 * before and after the student menu payload refreshes.
                 */
                const isSelected =
                  selectedColorCode === colorCode.code ||
                  (!!colorCode.id && selectedColorId === colorCode.id)

                return (
                  <ProfileSwatchWrapper
                    key={colorCode.id || colorCode.code}
                    $isSelected={isSelected}
                  >
                    <ProfileSwatchButton
                      type='button'
                      $color={colorCode.code}
                      $isSelected={isSelected}
                      aria-label={`Select ${colorCode.code} avatar color`}
                      aria-pressed={isSelected}
                      onClick={() => onProfileColorChange(colorCode)}
                    />
                  </ProfileSwatchWrapper>
                )
              })}
            </ProfileSwatchGrid>
          </ProfileSwatchSection>
          <ProfileDropdownDivider />
        </>
      )}

      <ProfileDropdownRow role='menuitemcheckbox' aria-checked={isDarkMode}>
        <span>Dark Mode</span>
        <label className='switch switch-small'>
          <input
            type='checkbox'
            className='switch-checkbox'
            checked={isDarkMode}
            onChange={onThemeModeChange}
            aria-label='Toggle dark mode'
          />
          <span className='switch-slider switch-slider-small'></span>
        </label>
      </ProfileDropdownRow>

      <ProfileDropdownDivider />

      <ProfileDropdownButton
        type='button'
        onClick={onSignOut}
        style={{ marginTop: 10, marginBottom: 5 }}
      >
        Sign Out
      </ProfileDropdownButton>
    </ProfileDropdownMenu>
  )
}

export default StudentProfileDropdownMenu
